import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { MobileLoggingComponent } from './mobile-logging.component';
import { ToastModule } from 'primeng';

const routes: Routes = [
  { path: '', component: MobileLoggingComponent, data: { title: 'Mobile Logging' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MobileLoggingRoutingModule {}

@NgModule({
  imports: [
    MobileLoggingRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ToastModule,
  ],
  declarations: [MobileLoggingComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MobileLoggingModule {}
